import { formatResponse } from "../utils/formatting";

const FormattedResponse = ({ response }) => {
  const formattedResponse = formatResponse(response);

  return <div dangerouslySetInnerHTML={{ __html: formattedResponse }} />;
};

export default FormattedResponse;
